const middleware = {}

middleware['anti-crawler'] = require('../middleware/anti-crawler.js')
middleware['anti-crawler'] = middleware['anti-crawler'].default || middleware['anti-crawler']

middleware['page-cache'] = require('../middleware/page-cache.js')
middleware['page-cache'] = middleware['page-cache'].default || middleware['page-cache']

middleware['spa'] = require('../middleware/spa.js')
middleware['spa'] = middleware['spa'].default || middleware['spa']

export default middleware
